export default "__VITE_ASSET__BO2YaJ9n__"